import React from 'react'
import { graphql } from 'gatsby'

// Components
import ShippingPolicyPage from './ShippingPolicyPage'

const ShippingPolicyIndex = (props) => {
  // console.log('SHIPPING POLICY PAGE INDEX (template)', props)
  return <ShippingPolicyPage {...props} />
}

export default ShippingPolicyIndex

export const shippingPolicyQuery = graphql`
  query ShippingPolicyQuery {
    ...SiteConfig
    prismicPage(uid: { eq: "shipping-policy" }) {
      uid
      type
      data {
        title
        content {
          raw
        }
      }
    }
  }
`
